import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Typography, Row, Input } from "antd";
import moment from "moment";
import _get from "lodash/get";

import { getVoteHistoryRequest } from "providers/ContestProvider/slice";
import BackButton from "components/BackButton";
import "./styles.less";

const { Search } = Input;

const VotingHistoryList = () => {
  const dispatch = useDispatch();
  const [searchKeyword, setSearchKeyword] = useState("");

  const voteHistory = useSelector((state) => state.contestSlice.voteHistory);
  const pagination = useSelector((state) => state.contestSlice.pagination);
  const isLoading = useSelector((state) => state.contestSlice.isLoading);

  const loadVoteHistory = (params = {}) => {
    const requestParams = {
      page: params.page || 1,
      limit: params.limit || 10,
      keyword: params.keyword || searchKeyword,
    };
    dispatch(getVoteHistoryRequest(requestParams));
  };

  useEffect(() => {
    loadVoteHistory();
  }, []);

  const handleTableChange = (tablePagination) => {
    loadVoteHistory({
      page: tablePagination.current,
      limit: tablePagination.pageSize,
      keyword: searchKeyword,
    });
  };

  const handleSearch = (value) => {
    setSearchKeyword(value);
    loadVoteHistory({ page: 1, keyword: value });
  };

  const columns = [
    {
      title: "Người bình chọn",
      dataIndex: "user",
      key: "voter",
      render: (user) => <span>{_get(user, "name", "N/A")}</span>,
    },
    {
      title: "Thí sinh",
      dataIndex: "candidate",
      key: "candidate",
      render: (candidate) => <span>{_get(candidate, "fullName", "N/A")}</span>,
    },
    {
      title: "Cuộc thi",
      dataIndex: "contest",
      key: "contest",
      render: (contest) => <span>{_get(contest, "name", "N/A")}</span>,
    },
    {
      title: "Số điểm",
      dataIndex: "score",
      key: "score",
      align: "center",
    },
    {
      title: "Thời gian",
      dataIndex: "createdAt",
      key: "date",
      render: (text) => moment(text).format("DD/MM/YYYY HH:mm"),
    },
  ];

  return (
    <div className="vote-history-wrapper">
      <Row
        className="vote-history-header"
        justify="space-between"
        align="middle"
      >
        <Row align="middle">
          <BackButton />
          <Typography.Title level={4}>Lịch sử bình chọn</Typography.Title>
        </Row>
      </Row>
      <div className="vote-history-content">
        <div className="filter-section">
          <Search
            placeholder="Tìm kiếm..."
            onSearch={handleSearch}
            enterButton
            style={{ width: 300 }}
          />
        </div>
        <Table
          columns={columns}
          dataSource={voteHistory}
          rowKey="_id"
          loading={isLoading}
          pagination={{
            current: pagination.page,
            pageSize: pagination.limit,
            total: pagination.total,
            showSizeChanger: true,
          }}
          onChange={handleTableChange}
          scroll={{ x: "max-content" }}
        />
      </div>
    </div>
  );
};

export default VotingHistoryList;
